import { Injectable } from '@angular/core';
import { CacheObjectService, DeviceService, HttpService, LogService } from '@app/core';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import {BehaviorSubject, Observable, of} from 'rxjs';
import { map } from 'rxjs/operators';
import {ISubscription, ResponseProcessWithDirectDebit} from './subscription.model';

import { SubscriptionStatus, SubscriptionStatusResponse } from './subscriptionStatusResponse';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private _durationRemainig: number | null = null;

  public get durationRemainig(): number | null {
    return this._durationRemainig;
  }

  public set durationRemainig(v: number | null) {
    this._durationRemainig = v;
  }

  private _remianingTextEndSubscription: string;

  public get remianingTextEndSubscription(): string {
    return this._remianingTextEndSubscription;
  }

  public set remianingTextEndSubscription(v: string) {
    this._remianingTextEndSubscription = v;
  }

  private _isShowSubscriptionButton: boolean;

  public get isShowSubscriptionButton(): boolean {
    return this._isShowSubscriptionButton;
  }

  public set isShowSubscriptionButton(v: boolean) {
    this._isShowSubscriptionButton = v;
  }


  private isEndremainingSubscriptionSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isEndremainingSubscription$: Observable<boolean> = this.isEndremainingSubscriptionSource.asObservable();
  private isEndedSubscriptionSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isEndedSubscription$: Observable<boolean> = this.isEndedSubscriptionSource.asObservable();

  constructor(
    private readonly parametersService: AppParametersService,
    private readonly cache: CacheObjectService<any>,
    private readonly log: LogService,
    private readonly http: HttpService) { }

  public getUserSubscriptionStatus(): Observable<SubscriptionStatusResponse> {
    this.log.logger('getUserSubscriptionStatus service start');
    const url = '/api/subscriptions/status';
    return this.http.post<SubscriptionStatusResponse>(url);
  }

  public getSubscriptionPlans() {
    this.log.logger('getSubscriptionPlans function from subscriptionServicestart');
    const clientId = this.parametersService.clientId;
    const url = `/api/subscriptions/plans?clientId=${clientId}`;
    return this.cache.getObjectCache(url);
  }

  public getNewSubscriptionPlans(): Observable<Array<ISubscription>> {
    this.log.logger('get new SubscriptionPlans function from subscriptionServicestart');
    const clientId = this.parametersService.clientId;
    const url = `/api/plans?clientId=${clientId}`;
   return this.http.get(url).pipe(map(z => z.items));
  }

  public checkUserSubscriptionStatus(): Observable<SubscriptionStatus> {
    this.log.logger('getUserSubscriptionStatus service start');
    const url = '/api/subscription/state';
    return this.http.post<SubscriptionStatus>(url, '');
  }

  public processWithDirectDebit(productId: string): Observable<ResponseProcessWithDirectDebit> {
    this.log.logger('getUserSubscriptionStatus service start');
    const url = '/api/orders/process-with-direct-debit/?productId=' + productId + '&source=app-test';
    return this.http.post(url,'');
  }

  public setStatusEndedRemainigSubscription(status: boolean) {
    this.isEndremainingSubscriptionSource.next(status);
  }

  public isEndedSubscription(state: boolean) {
    this.isEndedSubscriptionSource.next(state);
  }
}
